import { render } from "./myRoad.vue?vue&type=template&id=d645414c&scoped=true"
import script from "./myRoad.vue?vue&type=script&lang=js"
export * from "./myRoad.vue?vue&type=script&lang=js"

import "./myRoad.vue?vue&type=style&index=0&id=d645414c&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d645414c"]])

export default __exports__